import type { DynamicComponentOptions } from "@/lib/typing/types";
import { nextTick, shallowRef } from "vue";

const dialog = shallowRef<DynamicComponentOptions>();

const showDialog = (fields: DynamicComponentOptions) => {
  dialog.value = undefined;
  nextTick(() => {
    dialog.value = fields;
  });
};

export default function useContextMenu() {
  return { dialog, showDialog };
}